import React from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
};

const IconMessage: React.FC<Props> = ({
  width = 20,
  height = 20,
  color = '#23282E',
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 14.5C1.93533 14.5 1.87059 14.4873 1.80859 14.462C1.62193 14.3847 1.5 14.202 1.5 14V4C1.5 2.388 2.388 1.5 4 1.5H12C13.612 1.5 14.5 2.388 14.5 4V10C14.5 11.612 13.612 12.5 12 12.5H4.20736L2.354 14.3534C2.258 14.4494 2.13 14.5 2 14.5ZM4 2.5C2.94867 2.5 2.5 2.94867 2.5 4V12.7926L3.64665 11.646C3.74065 11.552 3.86733 11.4993 4 11.4993H12C13.0513 11.4993 13.5 11.0507 13.5 9.99935V3.99935C13.5 2.94802 13.0513 2.49935 12 2.49935H4V2.5ZM11.1667 5.66667C11.1667 5.39067 10.9427 5.16667 10.6667 5.16667H5.33333C5.05733 5.16667 4.83333 5.39067 4.83333 5.66667C4.83333 5.94267 5.05733 6.16667 5.33333 6.16667H10.6667C10.9427 6.16667 11.1667 5.94267 11.1667 5.66667ZM9.16667 8.33333C9.16667 8.05733 8.94267 7.83333 8.66667 7.83333H5.33333C5.05733 7.83333 4.83333 8.05733 4.83333 8.33333C4.83333 8.60933 5.05733 8.83333 5.33333 8.83333H8.66667C8.94267 8.83333 9.16667 8.60933 9.16667 8.33333Z"
      fill={color}
    />
  </svg>
);

export default IconMessage;
